import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TariffDetail } from '../../models/tariff-detail.model';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoginService } from '../../services/login.service';
import { TariffService } from '../../services/tariff.service';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { NotificationType } from 'src/app/core/models/ui-notification.model';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';

@Component({
  selector: 'app-tariff-detail',
  templateUrl: './tariff-detail.component.html',
  styleUrls: ['./tariff-detail.component.css']
})
export class TariffDetailComponent implements OnInit {

  form = new FormGroup({});
  tariff: TariffDetail;
  langs = [
    { 'lang': 'cs', 'title':'Česky' },
    { 'lang': 'en', 'title':'Anglicky' },
    { 'lang': 'de', 'title':'Německy' }
  ];

  constructor(
    private route: ActivatedRoute,
    private loginService: LoginService,
    private tariffService: TariffService,
    private tariffListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService
  ) { }

  ngOnInit() {
    this.tariff = this.route.snapshot.data.tariff;

    const defaultLang = this.tariff.language.filter(item => item.twoLetterISOLanguageName === 'cs')[0];

    this.form.addControl('code', new FormControl(this.tariff.code, Validators.required));
    this.form.addControl('maxLifts', new FormControl(this.tariff.maxLifts, Validators.required));
    this.form.addControl('maxUsers', new FormControl(this.tariff.maxUsers, Validators.required));
    this.form.addControl('maxLogDays', new FormControl(this.tariff.maxLogDays, Validators.required));
    this.form.addControl('lang', new FormControl(this.langs[0], Validators.required));
    this.form.addControl('title', new FormControl(defaultLang.title, Validators.required));
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onLangChange(event) {
    console.log(event);
    const lang = this.form.get('lang').value;
    const newLang = this.tariff.language.filter(item => item.twoLetterISOLanguageName === lang.lang)[0];

    this.form.patchValue({
      title: newLang.title
    });
  }

  onSubmit(modal: ModalComponent) {
    const lang = this.form.get('lang').value;
    let tariffLang = this.tariff.language.filter(item => item.twoLetterISOLanguageName != lang.lang);
    let current = this.tariff.language.filter(item => item.twoLetterISOLanguageName === lang.lang)[0];
    tariffLang.push({
      id: current.id,
      twoLetterISOLanguageName: lang.lang,
      title: this.form.get('title').value
    });

    if (this.form.valid && this.loginService.isSuperadmin()) {
      this.tariffService.update({
        id: this.tariff.id,
        code: this.form.get('code').value,
        maxLifts: this.form.get('maxLifts').value,
        maxUsers: this.form.get('maxUsers').value,
        maxLogDays: this.form.get('maxLogDays').value,
        language: tariffLang
      }).subscribe(() => {
        this.tariffListRefresh.refresh('tariff');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Tarif byl aktualizován'
        });
        modal.closeModal(null);
      });
    }
  }

}
